import { DefaultObject } from '@app-models/site';
import * as moment from 'moment';


export function addKeyAsId<T extends DefaultObject>(arr: T[]): T[] {
  const newArr: T[] = [];
  if (!arr) {
    return newArr;
  }
  for (const key in arr) {
    if (Object.prototype.hasOwnProperty.call(arr, key)) {
      const element: T = Object.assign({}, arr[key]);
      element.id = key;
      const a: any = element;
      if ('activeDatetime' in a && a.activeDatetime) {
        a.activeDatetime = moment(a.activeDatetime);
      }
      if ('expiredDatetime' in a && a.expiredDatetime) {
        a.expiredDatetime = moment(a.expiredDatetime);
      }
      if ('holidays' in a && a.holidays) {
        for (const h of a.holidays) {
          h.date = moment(h.date);
        }
      }
      newArr[key] = element;
    }
  }
  return newArr;
}

export function flattenKeyArray<T extends DefaultObject>(arr: T[]): T[] {
  const flats: T[] = [];
  for (const key in arr) {
    if (Object.prototype.hasOwnProperty.call(arr, key)) {
      const element: T = Object.assign({}, arr[key]);
      element.id = key;
      flats.push(element);
    }
  }
  return flats;
}
